import styled from "styled-components";

export const InnerSectionsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 0 0 16px 0;
  min-width: 96px;

  &:not(:last-child) {
    margin-right: 32px;
  }
`;
